// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_table__2nQyX {
    width: 100%;
    border-collapse: collapse;
}

.styles_table__2nQyX th {
    position: sticky;
    top: 0;
    background: #fbfbfb;
    padding: 10px 6px;
}

.styles_table__2nQyX th:not(.styles_empty__r5-Ri):after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    display: block;
    border-top: 1px solid #7b848e;
}

.styles_table__2nQyX th:first-child:after {
    margin-left: -10px;
}

.styles_table__2nQyX th:last-child:after {
    margin-right: -10px;
}

.styles_table__2nQyX th.styles_empty__r5-Ri:after {
    opacity: 0;
}

.styles_table__2nQyX td {
    border-bottom: 1px solid var(--light-grey);
    /*font-size: 14px;*/
    padding: 6px 10px;
    min-width: 100px;
}

.styles_bold__sxKGi {
    font-weight: 700;
}

.styles_right__IUohK {
    text-align: right;
}

.styles_left__Baq60 {
    text-align: left;
}

.styles_breakWord__BK7pX {
    word-break: break-word;
}

.styles_comments__bQFb0 {
    width: 402px;
    text-align: left;
}

.styles_highlight__jvs6R {
    background: rgba(22, 80, 180, 0.1);
}

.styles_highlightRed__kar7c {
    background: rgba(253, 111, 33, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/components/DealTaxesExpandedTable/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table th {\n    position: sticky;\n    top: 0;\n    background: #fbfbfb;\n    padding: 10px 6px;\n}\n\n.table th:not(.empty):after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    display: block;\n    border-top: 1px solid #7b848e;\n}\n\n.table th:first-child:after {\n    margin-left: -10px;\n}\n\n.table th:last-child:after {\n    margin-right: -10px;\n}\n\n.table th.empty:after {\n    opacity: 0;\n}\n\n.table td {\n    border-bottom: 1px solid var(--light-grey);\n    /*font-size: 14px;*/\n    padding: 6px 10px;\n    min-width: 100px;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.right {\n    text-align: right;\n}\n\n.left {\n    text-align: left;\n}\n\n.breakWord {\n    word-break: break-word;\n}\n\n.comments {\n    width: 402px;\n    text-align: left;\n}\n\n.highlight {\n    background: rgba(22, 80, 180, 0.1);\n}\n\n.highlightRed {\n    background: rgba(253, 111, 33, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `styles_table__2nQyX`,
	"empty": `styles_empty__r5-Ri`,
	"bold": `styles_bold__sxKGi`,
	"right": `styles_right__IUohK`,
	"left": `styles_left__Baq60`,
	"breakWord": `styles_breakWord__BK7pX`,
	"comments": `styles_comments__bQFb0`,
	"highlight": `styles_highlight__jvs6R`,
	"highlightRed": `styles_highlightRed__kar7c`
};
export default ___CSS_LOADER_EXPORT___;
